import { Datoblock } from "./Types";

export interface ConfirmationQueryResponse {
    roadside?: {
        txnConfirmationTextUpper: Datoblock;
        txnConfirmationTextLower: Datoblock;
    };
    lifestyle?: {
        txnConfirmationTextUpper: Datoblock;
        txnConfirmationTextLower: Datoblock;
    };
}

export const ConfirmationQuery = `
{
    roadside {
        txnConfirmationTextUpper {
            blocks
            links
            value
        }
        txnConfirmationTextLower {
            blocks
            links
            value
        }
    }
    lifestyle {
        txnConfirmationTextUpper {
            blocks
            links
            value
        }
        txnConfirmationTextLower {
            blocks
            links
            value
        }
    }
}`;
